import React from 'react';
import styled from 'styled-components';

const InputContainer = styled.div`
  margin-bottom: 1rem;
`;

const Label = styled.label`
  display: block;
  margin-bottom: 0.5rem;
  color: #4A3C31;
  font-weight: 600;
`;

const Input = styled.input`
  width: 100%;
  padding: 0.75rem;
  border: 1px solid ${props => props.$error ? '#FF6B6B' : '#E8D5B5'};
  border-radius: 4px;
  font-size: 1rem;
  color: #2C1810;
  
  &:focus {
    outline: none;
    border-color: ${props => props.$error ? '#FF6B6B' : '#8C7355'};
  }
  
  &::placeholder {
    color: #8C7355;
  }
`;

const ErrorText = styled.div`
  color: #FF6B6B;
  font-size: 0.875rem;
  margin-top: 0.25rem;
`;

const TextInputField = ({ label, error, ...props }) => {
  return (
    <InputContainer>
      {label && <Label>{label}</Label>}
      <Input $error={!!error} {...props} />
      {error && <ErrorText>{error}</ErrorText>}
    </InputContainer>
  );
};

export default TextInputField;
